import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import { PDFDownloadLink } from '@react-pdf/renderer'
import moment from 'moment'
import GenerarPdfOneTableOnly from '../../../../Forms/SharedComponents/containers/GenerarPdf/GenerarPdfOneTableOnly'
import { IPdfDownloadLinkReporteLaridaeViewProps } from './interfaces'
import { COLORES } from '../../../../../config/colores'

export const PdfDownloadLinkReporteLaridaeView = ({
  filas,
  columnas,
  titulo,
  descripcion,
  versionLaridae,
  orientacion='portrait'
}: IPdfDownloadLinkReporteLaridaeViewProps) => (
  <PDFDownloadLink
    document={
        <GenerarPdfOneTableOnly
        orientacion={orientacion}
        data={filas}
        fields={columnas}
        info={{
          titulo,
          descripcion,
          subtitulo: `Fecha: ${moment().format('DD/MM/YYYY')}`,
          version: `${versionLaridae}`,
        }}
      />
    }
    fileName={`${titulo}.pdf`}
    style={{
      textDecoration: 'none',
      marginTop:'12px',
      color: COLORES.blue.light,      
      fontSize: '16px',    
      fontFamily: 'sans-serif', 
      borderRadius: '5px 5px 5px 5px',
    }}
  >
    {({ blob, url, loading, error }) =>
      loading ? (
        '...'
      ) : (
        <Tooltip title={'Guardar en PDF'}>
          <PictureAsPdfIcon fontSize="default" />
        </Tooltip>
      )
    }
  </PDFDownloadLink>
);
